import { API_URL } from './Constants';
import ApiService from './ApiService';


class AdminApi {
    static getListTinTucAdmin = async (pageNumber, postType, catId, titleSearch) => {
        try {
            // Initialize params with mandatory parameter
            let params = { pageNumber };

            // Add optional parameters only if they are not null or undefined
            if (postType != null) params.postType = postType;
            if (catId != null) params.catId = catId;
            if (titleSearch != null && titleSearch.trim() !== "") params.titleSearch = titleSearch;

            return await ApiService.getDataWithParams(API_URL + "/tin-tuc/admin/list", params);
        } catch (error) {
            console.error(error);
        }
    };

    static deletePost = async (postId) => {
        try {
            let url = `/tin-tuc/delete/${postId}`
            const response = await ApiService.deletePost(API_URL + url);
            return response;
        } catch (error) {
            console.error(error);
        }
    };

    static deleteVideoPost = async (postId) => {
        try {
            let url = `/video/admin/delete/${postId}`
            const response = await ApiService.deletePost(API_URL + url);
            return response;
        } catch (error) {
            console.error(error);
        }
    };

    static deleteAudioPost = async (postId) => {
        try {
            let url = `/audio/admin/delete/${postId}`
            const response = await ApiService.deletePost(API_URL + url);
            return response;
        } catch (error) {
            console.error(error);
        }
    };

    static deleteKinhSachPost = async (postId) => {
        try {
            let url = `/kinh-sach/admin/delete/${postId}`
            const response = await ApiService.deletePost(API_URL + url);
            return response;
        } catch (error) {
            console.error(error);
        }
    };

    static deleteThongBaoPost = async (postId) => {
        try {
            let url = `/thong-bao/delete/${postId}`
            const response = await ApiService.deletePost(API_URL + url);
            return response;
        } catch (error) {
            console.error(error);
        }
    };

    static deleteHinhAnhPost = async (postId) => {
        try {
            let url = `/hinh-anh/delete/${postId}`
            const response = await ApiService.deletePost(API_URL + url);
            return response;
        } catch (error) {
            console.error(error);
        }
    };

    static deleteGiangSuPost = async (postId) => {
        try {
            let url = `/giang-su/delete/${postId}`
            const response = await ApiService.deletePost(API_URL + url);
            return response;
        } catch (error) {
            console.error(error);
        }
    };

    static deleteTrangPost = async (postId) => {
        try {
            let url = `/trang/admin/delete/${postId}`
            const response = await ApiService.deletePost(API_URL + url);
            return response;
        } catch (error) {
            console.error(error);
        }
    };

    static deleteNhacPhatGiaoPost = async (postId) => {
        try {
            let url = `/nhac-phat-giao/admin/delete/${postId}`
            const response = await ApiService.deletePost(API_URL + url);
            return response;
        } catch (error) {
            console.error(error);
        }
    };

    static deleteSachNoiPost = async (postId) => {
        try {
            let url = `/sach-noi/admin/delete/${postId}`
            const response = await ApiService.deletePost(API_URL + url);
            return response;
        } catch (error) {
            console.error(error);
        }
    };

    static deleteGuongSangTuHanhPost = async (postId) => {
        try {
            let url = `/guong-sang-tu-hanh/delete/${postId}`
            const response = await ApiService.deletePost(API_URL + url);
            return response;
        } catch (error) {
            console.error(error);
        }
    };

    static deleteAudioTheoBoPost = async (postId) => {
        try {
            let url = `/audio-theo-bo/admin/delete/${postId}`
            const response = await ApiService.deletePost(API_URL + url);
            return response;
        } catch (error) {
            console.error(error);
        }
    };

    static deleteSlideShowHeaderPost = async (postId) => {
        try {
            let url = `/slideshow-header/admin/delete/${postId}`
            const response = await ApiService.deletePost(API_URL + url);
            return response;
        } catch (error) {
            console.error(error);
        }
    };

    static deleteSlideShowHomePost = async (postId) => {
        try {
            let url = `/slideshow-home/admin/delete/${postId}`
            const response = await ApiService.deletePost(API_URL + url);
            return response;
        } catch (error) {
            console.error(error);
        }
    };

    // ---------------- MEDIA FILE -------------------
    static getMediaFile = async (postId) => {
        try {
            let url = `/hinh-anh/media/list/${postId}`
            const response = await ApiService.getDataWithParams(API_URL + url);
            return response;
        } catch (error) {
            console.error(error);
        }
    };

    static deleteMediaFile = async (postId) => {
        try {
            let url = `/hinh-anh/media/delete/${postId}`
            const response = await ApiService.deletePost(API_URL + url);
            return response;
        } catch (error) {
            console.error(error);
        }
    };

    // ---------------- SYSTEM MANAGEMENT -------------------
    static getSettings = async () => {
        return await ApiService.getDataWithParams(API_URL + "/settings");
    };

    static getSettingGroups = async () => {
        return await ApiService.getDataWithParams(API_URL + "/setting-groups");
    };

    static getMenus = async () => {
        return await ApiService.getDataWithParams(API_URL + "/menus");
    };

    static getMenuItems = async () => {
        return await ApiService.getDataWithParams(API_URL + "/menu-items");
    };

    static getRoles = async () => {
        return await ApiService.getDataWithParams(API_URL + "/roles");
    };

    static getPermissions = async () => {
        return await ApiService.getDataWithParams(API_URL + "/permissions");
    };

    static getAccountList = async () => {
        return await ApiService.getDataWithParams(API_URL + "/account/list");
    };

    static getEmails = async () => {
        return await ApiService.getDataWithParams(API_URL + "/emails");
    };

    static getEmailSubscribes = async () => {
        return await ApiService.getDataWithParams(API_URL + "/email-subscribes");
    };

    static updateEmail = async (id, emailData) => {
        return await ApiService.putData(API_URL + "/emails/" + id, emailData);
    };

    // ---------------- MEMBER MANAGEMENT -------------------
    static getMemberList = async () => {
        return await ApiService.getDataWithParams(API_URL + "/admin/members/list");
    };

    static updateMemberRole = async (userId, roleId) => {
        return await ApiService.putData(API_URL + `/admin/members/${userId}/role?roleId=${roleId}`);
    };

    static deleteMember = async (userId) => {
        return await ApiService.deletePost(API_URL + `/admin/members/${userId}`);
    };

    static createMember = async (memberData) => {
        return await ApiService.postData(API_URL + "/admin/members/create", memberData);
    };

    // ---------------- ROLE & PERMISSION -------------------
    // (getRoles đã định nghĩa ở phần SYSTEM MANAGEMENT phía trên — bỏ bản trùng)
    static getRoleById = async (id) => {
        return await ApiService.getDataWithParams(API_URL + "/roles/" + id);
    };

    static saveRole = async (roleData) => {
        if (roleData.roleid) {
            return await ApiService.putData(API_URL + "/roles/" + roleData.roleid, roleData);
        }
        return await ApiService.postData(API_URL + "/roles", roleData);
    };

    static deleteRole = async (id) => {
        return await ApiService.deletePost(API_URL + "/roles/" + id);
    };

    static getPermissions = async () => {
        return await ApiService.getDataWithParams(API_URL + "/permissions");
    };

    static getRolePermissions = async (roleId) => {
        return await ApiService.getDataWithParams(API_URL + "/admin/role-permissions/" + roleId);
    };

    static updateRolePermissions = async (roleId, permissions) => {
        return await ApiService.postData(API_URL + "/admin/role-permissions/" + roleId, permissions);
    };

    // ---------------- APPROVAL WORKFLOW (feature 002) -------------------
    static getPendingPosts = async (pageNumber = 1) => {
        return await ApiService.getDataWithParams(API_URL + "/approval/pending", { pageNumber });
    };

    static approvePost = async (postId) => {
        return await ApiService.postData(API_URL + `/approval/${postId}/approve`);
    };

    static rejectPost = async (postId, note) => {
        return await ApiService.postData(API_URL + `/approval/${postId}/reject`, { note });
    };

    // ---------------- SELF PROFILE (feature 002) -------------------
    static getMe = async () => {
        return await ApiService.getDataWithParams(API_URL + "/account/me");
    };

    // accountData: {name, address, password (cũ), newPassword}
    static updateMe = async (accountData) => {
        const formData = new FormData();
        formData.append("account", new Blob([JSON.stringify(accountData)], { type: "application/json" }));
        const token = localStorage.getItem('token');
        const headers = token ? { 'Authorization': `Bearer ${token}` } : {};
        const axios = (await import('axios')).default;
        try {
            const response = await axios.put(API_URL + "/account/me/update", formData, { headers });
            return { ok: true, data: response.data };
        } catch (error) {
            return { ok: false, status: error.response ? error.response.status : null, data: error.response ? error.response.data : null };
        }
    };

    // ---------------- ACCOUNT MANAGEMENT (hệ auth thật /account/*) -------------------
    static registerAccount = async (accountData) => {
        const formData = new FormData();
        formData.append("account", new Blob([JSON.stringify(accountData)], { type: "application/json" }));
        const token = localStorage.getItem('token');
        const headers = token ? { 'Authorization': `Bearer ${token}` } : {};
        const axios = (await import('axios')).default;
        try {
            const response = await axios.post(API_URL + "/account/register", formData, { headers });
            return { ok: true, data: response.data };
        } catch (error) {
            return { ok: false, status: error.response ? error.response.status : null, data: error.response ? error.response.data : null };
        }
    };

    static updateAccount = async (accountData) => {
        const formData = new FormData();
        formData.append("account", new Blob([JSON.stringify(accountData)], { type: "application/json" }));
        const token = localStorage.getItem('token');
        const headers = token ? { 'Authorization': `Bearer ${token}` } : {};
        const axios = (await import('axios')).default;
        try {
            const response = await axios.put(API_URL + "/account/update", formData, { headers });
            return { ok: true, data: response.data };
        } catch (error) {
            return { ok: false, status: error.response ? error.response.status : null, data: error.response ? error.response.data : null };
        }
    };

    static deleteAccount = async (accountId) => {
        return await ApiService.deletePost(API_URL + `/account/${accountId}`);
    };

    // ---------------- MENU CRUD (feature 002 - menu động) -------------------
    static saveMenu = async (menu) => {
        if (menu.id) return await ApiService.putData(API_URL + `/menus/${menu.id}`, menu);
        return await ApiService.postData(API_URL + "/menus", menu);
    };

    static saveMenuItem = async (item) => {
        if (item.id) return await ApiService.putData(API_URL + `/menu-items/${item.id}`, item);
        return await ApiService.postData(API_URL + "/menu-items", item);
    };

    static deleteMenuItem = async (id) => {
        return await ApiService.deletePost(API_URL + `/menu-items/${id}`);
    };
}

export default AdminApi;